/**
 * merchantInfo
 * 商户信息
 */

export default {
  namespaced: true,
  state: {
    //商户类型
    merchantType: "",
    merchantInfo: {},
    //商户购买类型
    merchantBuyType: "", //CRYPTO-币本位
    merchant_equipmentEnd: "web", //4-app、web
    isNoCodePay: false, // 统一大写处理 -- CODEPAY
  },
  mutations: {
    set_merchantType(state, val) {
      state.merchantType = val;
    },
    set_merchantBuyType(state, val) {
      state.merchantBuyType = val;
    },
    set_merchantInfo(state, val) {
      // console.log('val?.appId', val?.appId);
      state.merchantInfo = val;
      const noCodePayDisabledAppIds = [""];
      state.isNoCodePay = !noCodePayDisabledAppIds.includes(val?.appId);
    },
    set_merchant_equipmentEnd(state, val) {
      state.merchant_equipmentEnd = val;
    },
  },
};
